import { AnyObjectSchema, object, string } from 'yup';

const validationSchema = (fieldName: string): AnyObjectSchema =>
  object().shape({
    [`${fieldName}`]: string().nullable(),
  });

export default validationSchema;
